import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const getFacilities = (setFacilityData) => {
  axiosInstance
    .get("/facility/list", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setFacilityData(res.data.data);
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};

export const addFacility = (FormData, setFormData, setFacilityData) => {
  axiosInstance
    .post("/facility/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Facility added successfully") {
        toast.success("Facility Added");
        setFormData({
          facilityName: "",
          icon: "",
          status: 1,
          createdAt: new Date().toISOString(),
        });
        getFacilities(setFacilityData);
      } else {
        toast.error("Something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};
export const updateFacility = (FormData, setFormData, setFacilityData) => {
  axiosInstance
    .put("/facility/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Facility updated successfully") {
        toast.success("Facility updated");
        setFormData({
          facilityName: "",
          icon: "",
          status: 1,
          createdAt: new Date().toISOString(),
        });
        getFacilities(setFacilityData);
      } else {
        toast.error("Something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};

export const deleteFacility = (id, setFacilityData) => {
  axiosInstance
    .delete(
      "/facility/delete",
      {
        data: { id: id },
      },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Facility deleted successfully") {
        toast.success("Facility deleted");

        getFacilities(setFacilityData);
      } else {
        toast.error("Something went Wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went Wrong");
    });
};
